const styles = {
  merchantName: {
    fontSize: '1.375rem !important',
    margin: '0 !important',
    paddingLeft: '1rem !important',
  },
  image: {
    width: '3.75em !important',
    height: '3.75em !important',
    borderRadius: '.5625rem !important',
  },
  statusPill: {
    alignItems: 'center !important',
    borderRadius: '.625rem !important',
    backgroundColor: '#a9b8c2 !important',
    color: '#fff !important',
    display: 'flex !important',
    fontSize: '.75rem !important',
    height: '1.125rem !important',
    justifyContent: 'center !important',
    width: '4.75rem !important',
    marginLeft: 'auto !important',
    padding: '0 !important',
    textAlign: 'center',
    '&.activePill': {
      backgroundColor: '#39e27a !important',
    },
  },
  paddingInfo: {
    padding: '.5625rem 0 !important',
  },
  container: {
    backgroundColor: '#fff',
    padding: '.625rem 1.25rem !important',
    borderRadius: '.25rem !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05)',
    margin: '.625em -1em !important',
  },
  merchantMeta: {
    width: '40% !important',
    margin: '0 !important',
    padding: '0  !important',
    display: 'flex !important',
    alignItems: 'center !important',
    paddingRight: '1rem !important',
    borderRight: 'solid 1px #e2e6e8',
  },
  merchantStats: {
    width: '60% !important',
    margin: '0 !important',
    padding: '0  !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'right !important',
  },
  label: {
    color: '#999 !important',
    fontSize: '.625rem !important',
    fontWeight: 'bold !important',
    letterSpacing: '.125rem !important',
    textTransform: 'uppercase !important',
    textAlign: 'left !important',
  },
  value: {
    textAlign: 'left !important',

    '& > span': {
      fontWeight: '500 !important',
    },
  },
  '@global .ui.statistics': {
    margin: '0 !important',
  },
  '@global .ui.statistics .statistic > .value': {
    color: '#683caf !important',
    fontSize: '1.875rem !important',
    marginTop: '.625rem !important',
  },
};

export default styles;
